import React, { useState, useEffect, useContext, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import { postAxios } from '../../axios/Axios';
import request from '../../request/request';
import moment from 'moment';
import Loader from '../loader/Loader';
import { LoadingContext } from '../../context/Provider';
import InquiryFilterDrawer from './InquiryFilterDrawer';
import { IoMdRefresh } from 'react-icons/io';
import { formatNumberWithCommas } from '../../utils/helper';
import { useGlobal } from '../../context/GlobalContext';

export default function Inquiry() {
    const { loading, loadingEnabled, loadingDisabled } = useContext(LoadingContext);
    const { setDashboardTitle } = useGlobal();
    const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);
    const [products, setProducts] = useState([]);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    // Filters
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [senderName, setSenderName] = useState("");
    const [senderEmail, setSenderEmail] = useState("");
    const [senderMobile, setSenderMobile] = useState("");
    const [recieverParty, setRecieverParty] = useState("");
    const [recieverName, setRecieverName] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [dataBySearch, setDataBySearch] = useState(false);
    const [myApiData, setMyApiData] = useState({});

    const fetchData = useCallback(async () => {
        loadingEnabled();

        try {
            const payload = {
                ...(dataBySearch ? myApiData : {}),
                meta: { jtStartIndex: first, jtPageSize: rows }
            };

            const res = await postAxios(request.getInquiry, payload);

            setProducts(res?.data?.records || []);
            setTotalRecords(res?.data?.metadata?.total || 0);
        } catch (error) {
            console.error("Inquiry Fetch Error:", error);
        } finally {
            loadingDisabled();
        }
    }, [first, rows, dataBySearch, myApiData]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Pagination
    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    // Table Bodies
    const messageBody = (rowData) => (
        <div dangerouslySetInnerHTML={{ __html: rowData.message }} />
    );

    const postingByBody = (rowData) => (
        <div>
            <div>{rowData.sender_name}</div>
            <div>Email: {rowData.sender_email}</div>
            <div>Mobile: {rowData.sender_mobile}</div>
        </div>
    );

    const generatedBody = (rowData) => (
        <div>
            {moment(rowData.generated * 1000).format('DD/MM/YYYY')}
            <br />
            {moment(rowData.generated * 1000).format('LTS')}
            <br />
            {moment(rowData.generated * 1000).fromNow()}
        </div>
    );

    // 🔎 Search
    const handleSubmit = async (e) => {
        e.preventDefault();

        setFirst(0); // reset pagination
        setDataBySearch(true);

        let fieldData = {};

        if (title) fieldData.title = title;
        if (message) fieldData.message = message;
        if (senderName) fieldData.sender_name = senderName;
        if (senderMobile) fieldData.sender_mobile = senderMobile;
        if (senderEmail) fieldData.sender_email = senderEmail;
        if (recieverParty) fieldData.receiver_party_id = recieverParty;
        if (recieverName) fieldData.receiver_name = recieverName;
        if (fromDate) fieldData.date_from = moment(fromDate).format("YYYY-MM-DD");
        if (toDate) fieldData.date_to = moment(toDate).format("YYYY-MM-DD");

        setMyApiData(fieldData);
    };

    // 🔄 Reset
    const resetFunction = () => {
        setTitle("");
        setMessage("");
        setSenderName("");
        setSenderEmail("");
        setSenderMobile("");
        setRecieverParty("");
        setRecieverName("");
        setFromDate(null);
        setToDate(null);
        setDataBySearch(false);
        setMyApiData({});
        setFirst(0);
    };

    useEffect(()=> {
        setDashboardTitle('Inquiry');
    }, [])

    return (
        <div className="card">
            {loading && <Loader />}

            <div className='d-flex justify-content-between align-items-center m-2'>
                <div>
                    <span className='fw-bold'>Total Records:</span> {totalRecords ? formatNumberWithCommas(totalRecords) : 0}
                </div>

                <div className="d-flex gap-2 flex-row  justify-content-end align-items-center prime-react-btn">
                    <Button
						variant="outline-secondary"
						disabled={loading}
						onClick={() => setFilterDrawerVisible(true)}
					>
						<i className="pi pi-filter" />
					</Button>

                    <button
                        className="btn submit-btm text-white"
                        onClick={fetchData}
                    >
                        <IoMdRefresh size="1.2em" />
                    </button>
                </div>
            </div>

            <DataTable value={products} showGridlines>
                <Column field="title" header="Title" />
                <Column body={messageBody} header="Message" />
                <Column body={postingByBody} header="Posting By" />
                <Column field="receiver_name" header="Receiver" />
                <Column body={generatedBody} header="Generated" />
            </DataTable>

            <Paginator
                first={first}
                rows={rows}
                totalRecords={totalRecords}
                rowsPerPageOptions={[10, 20, 30, 50, 100]}
                onPageChange={onPageChange}
            />

            <InquiryFilterDrawer
                visible={filterDrawerVisible}
                setVisible={setFilterDrawerVisible}
                title={title}
                setTitle={setTitle}
                message={message}
                setMessage={setMessage}
                senderName={senderName}
                setSenderName={setSenderName}
                senderEmail={senderEmail}
                setSenderEmail={setSenderEmail}
                senderMobile={senderMobile}
                setSenderMobile={setSenderMobile}
                recieverParty={recieverParty}
                setRecieverParty={setRecieverParty}
                recieverName={recieverName}
                setRecieverName={setRecieverName}
                fromDate={fromDate}
                setFromDate={setFromDate}
                toDate={toDate}
                setToDate={setToDate}
                handleSubmit={handleSubmit}
                resetFunction={resetFunction}
                loading={loading}
            />
        </div>
    );
}
